import { render, staticRenderFns } from "./AccreditationMediationFamiliale.vue?vue&type=template&id=4dc9ab66"
import script from "./AccreditationMediationFamiliale.vue?vue&type=script&lang=js"
export * from "./AccreditationMediationFamiliale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports